// extracted by mini-css-extract-plugin
export default {"wrapper":"cursor-pagination_wrapper__y5U1D"};